/* eslint-disable max-len */
import styled from 'styled-components';
import { getCssVar } from '../../../common/utils';
import { AllieText } from '../../../components/Text';


export const StyledDescText = styled(AllieText)`
  font-size: 12px;
  white-space: nowrap;

  @media (min-width: ${() => getCssVar('--breakpoint-desktop-lg', '1600px')}) {
    font-size: 14px !important;
    line-height: 19px !important;
  }

  @media (min-width: ${() => getCssVar('--breakpoint-desktop-xl', '1920px')}) {
    font-size: 16px !important;
    line-height: 22px !important;
  }
`;


export const ProductionCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: var(--allie-shadow-md);
  border: 1px solid var(--allie-color-neutral-30);
  border-bottom: 1px solid var(--allie-color-light-30);
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  h2 {
    font-size: 24px;
    font-weight: 600;
    margin: 0;
  }
`;

export const ProductInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
`;

export const ProductionStats = styled.div`
  display: flex;
  justify-content: space-evenly;
  background-color: var(--allie-color-light-80);
  margin-bottom: 24px;
`;

export const StatBlock = styled.div`
  text-align: center;
`;

export const ProductionValue = styled.p`
  font-size: 32px;
  font-weight: 500;
  margin: 0;
`;
